import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  truckFactorData: any;
}
interface IProps {
  GridHeight?: any;
}
export class TruckFactor extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private truckFactorId: number = -1;
  private isAdd: boolean = true;
  private title: string = '';
  private type = 'trackfactor';
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      visibleDeleteDialog: false,
      truckFactorData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public validationRule: Object = { required: true };
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteTruckFactor() {
    const obj = {
      id: this.truckFactorId,
    };
    
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getTruckFactor(this.type);
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addTruckFactor(objCommer: any) {
    loadingShow(true, 'Adding');
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      truck_factor: objCommer.truck_factor,
      asset_no: objCommer.asset_no,
      id: objCommer.id,
      type: 'trackfactor',
    };

    if (this.isAdd) {
      delete obj.id
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          
              Message.success('Successfully');
              this.getTruckFactor(this.type);
              this.setState({ visibleAddDialog: false });
            
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        });
    } else {
       EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          
              Message.success('Successfully');
              this.getTruckFactor(this.type);
              this.setState({ visibleAddDialog: false });
           
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
          Message.error(err.response.data+"\n"+err.response.status+"\n"+err.response.headers);
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        });
    }
  }
  componentDidMount() {
    this.getTruckFactor(this.type);
  }

  getTruckFactor(type: string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ truckFactorData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getTruckFactor(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addTruckFactor(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addTruckFactor(args.data);
    } else if (args.requestType === 'delete') {
      this.truckFactorId = args.data[0].id;
      this.deleteTruckFactor();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.truckFactorData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowExcelExport
          enablePersistence
          actionBegin={this.actionBegin.bind(this)}
          allowGrouping={true}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='asset_no'
              headerText='Asset No'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='truck_factor'
              headerText='Truck Factor'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
              Group
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default TruckFactor;
